import { DiscountCode } from "@ticketingplatform/api/dist/discountCode/fragments/__generated__/discountCode";
import { Popconfirm } from "antd";
import DisabledContext from "antd/es/config-provider/DisabledContext";
import { ColumnsType, ColumnType } from "antd/es/table";
import { DeleteIcon } from "assets/icons";
import { useContext, useMemo } from "react";
import { useIntl } from "react-intl";
import { renderTableAmountColumn } from "utils/tableUtils";

import { UseDiscountCodeListColumns } from "./types";

export const useDiscountCodeListColumns: UseDiscountCodeListColumns = ({
  onDelete,
}) => {
  const intl = useIntl();
  const disabled = useContext(DisabledContext);
  const actionColumn = useMemo<ColumnType<DiscountCode>>(
    () => ({
      title: intl.formatMessage({
        defaultMessage: "Action",
      }),
      key: "action",
      render: (_, { id, name }) => (
        <Popconfirm
          title={intl.formatMessage(
            {
              defaultMessage:
                "Are you sure you want to delete Discount Code: {name}?",
            },
            { name }
          )}
          onConfirm={() => onDelete?.(id)}
        >
          <DeleteIcon />
        </Popconfirm>
      ),
    }),
    [intl, onDelete]
  );

  return useMemo<ColumnsType<DiscountCode>>(
    () => [
      {
        title: intl.formatMessage({
          defaultMessage: "Discount Code",
        }),
        dataIndex: "code",
      },
      {
        title: intl.formatMessage({
          defaultMessage: "Discount Name",
        }),
        key: "name",
        dataIndex: "name",
      },
      {
        title: intl.formatMessage({
          defaultMessage: "Discount",
        }),
        key: "amount",
        dataIndex: "amount",
        render: renderTableAmountColumn(),
      },
      ...(disabled ? [] : [actionColumn]),
    ],
    [actionColumn, disabled, intl]
  );
};
